var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "package-type" },
    [
      _c(
        "v-tabs",
        {
          attrs: {
            change: _vm.changeTab(_vm.tab),
            "next-icon": "mdi-arrow-right-bold-box-outline",
            "prev-icon": "mdi-arrow-left-bold-box-outline",
            "show-arrows": "",
          },
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        [
          _c("v-tabs-slider"),
          _vm._v(" "),
          _vm._l(_vm.items, function (item) {
            return _c("v-tab", [
              _c("span", { staticClass: "package-type__tab" }, [
                _vm._v(
                  "\n                       " +
                    _vm._s(item.tabLabel) +
                    "\n                "
                ),
              ]),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.tab,
            callback: function ($$v) {
              _vm.tab = $$v
            },
            expression: "tab",
          },
        },
        _vm._l(_vm.items, function (item) {
          return _c(
            "v-tab-item",
            [
              _c("v-card", { attrs: { flat: "" } }, [
                _c(
                  "div",
                  { staticClass: "package-type__content" },
                  [
                    _c(
                      "div",
                      { staticClass: "position-relative" },
                      [
                        _c("img", {
                          staticClass: "package-type__img",
                          attrs: { src: item.tabImg, alt: "" },
                        }),
                        _vm._v(" "),
                        _c(
                          "v-tabs",
                          {
                            attrs: { change: _vm.changeTab(_vm.point) },
                            model: {
                              value: _vm.point,
                              callback: function ($$v) {
                                _vm.point = $$v
                              },
                              expression: "point",
                            },
                          },
                          _vm._l(item.tabDots, function (dot, idx) {
                            return _c(
                              "v-tab",
                              {
                                key: idx,
                                staticClass: "package-type__dots",
                                class: item.tabDots.length > 1 ? "" : "d-none",
                                style: {
                                  left: dot.tabDotX + "%",
                                  top: dot.tabDotY + "%",
                                },
                              },
                              [_c("div", { staticClass: "package-type__dot" })]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-tabs-items",
                      {
                        model: {
                          value: _vm.point,
                          callback: function ($$v) {
                            _vm.point = $$v
                          },
                          expression: "point",
                        },
                      },
                      _vm._l(item.tabDots, function (info) {
                        return _c(
                          "v-tab-item",
                          [
                            _c(
                              "v-card",
                              { attrs: { flat: "" } },
                              [
                                _c("v-card", [
                                  _c(
                                    "div",
                                    { staticClass: "package-type__info" },
                                    [
                                      _vm._l(
                                        info.tabContentInfo,
                                        function (text, index) {
                                          return _c("div", {
                                            key: index,
                                            domProps: {
                                              innerHTML: _vm._s(
                                                text.tabContentDescr
                                              ),
                                            },
                                          })
                                        }
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "package-type__btn btn-red",
                                          attrs: {
                                            href: "javascript:void(0)",
                                            onclick: "scrollOnBlock(formNew)",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                                            Оставить заявку для подбора решения\n                                        "
                                          ),
                                        ]
                                      ),
                                    ],
                                    2
                                  ),
                                ]),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          )
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }